@if (remoteContent$ | async; as content) {
  <div>
    <app-layout-default>
      <div>
        <h1 data-cy="contactInfoPageTitle" class="c11n-text-2xl-headline margin-bottom-3" [innerHTML]="content.pageTitle">
        </h1>
        <p data-cy="useOfResidenceMsg" class="margin-bottom-2" [innerHTML]="content.useOfResidenceMsg"></p>
        <vgim-personal-address></vgim-personal-address>
        <vgim-personal-phone></vgim-personal-phone>
        <div class="secure-link row">
          <vgim-secure-link></vgim-secure-link>
        </div>
      </div>
      <div layout-last-column>
        <c11n-button id="contactInfoBTN" (clickEvent)="nextPage()" [labelText]="content.continueButton" fullWidth="true">
        </c11n-button>
        <app-cancel></app-cancel>
        <app-feedback-survey></app-feedback-survey>
      </div>
    </app-layout-default>
  </div>
}
